<template>
  <div class="topBannerMobile">
    <b-row>
      <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-5 pt-4">
        <div class="text-container zoom-on-hover">
          <h1 class="text-banner roboto-n mb-3">
            Da <span class="c-orange">implementação</span><br>
            até a <span style="font-weight: 900;">divulgação</span>
          </h1>

          <span class="text-banner-span roboto-n">
            A <span style="font-weight: 900;">Constr UP</span> surgiu da necessidade <br>
            de facilitar a migração das lojas de <br>
            materiais de construção para o <br>
            digital.
          </span>
        </div>
      </b-col>
      <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-5 pt-4">
        <div class="image-container">
          <img src="@/assets/img/new-banner.png" alt="Banner" class="zoom-on-hover" width="100%">
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.topBannerMobile {
  margin-top: 185px;
  padding: 0 15px 0 0;
}

.text-banner {
  color: #FFF;
  font-size: 3.3rem;
  letter-spacing: 2px;
}

.text-banner-span {
  color: #FFF;
  font-weight: 100 !important;
  font-size: 1.7rem;
  line-height: 35px;
  letter-spacing: 1.5px;
}

.text-container {
  margin-left: 15%;
  margin-top: 3%;  
}

.image-container {
  overflow: hidden;
}

.zoom-on-hover {
  transition: transform 0.3s ease;
}

.zoom-on-hover:hover {
  transform: scale(1.1);
}

@media screen and (max-width: 1000px) {
  .topBannerMobile {
    margin-top: 115px;
  }
  .text-banner {
    font-size: 2rem;
    letter-spacing: 1px;
  }

  .text-banner-span {
    font-size: 1.1rem;
    line-height: 25px;
    letter-spacing: 1px;
  }

  .text-container {
    margin-left: 10%;
  }
}
</style>
